// extracted by mini-css-extract-plugin
export default {"floatingDiv":"style_floatingDiv__H522s","floatingdiv":"style_floatingdiv__d2HHW"};